import * as React from 'react';
import { RichTextBlock } from 'prismic-reactjs';

import {
  Link,
  List,
  ListItem,
  ListItemText,
  WithStyles,
  withStyles,
} from '@nelnet/unifi-components-react';
import styles from './styles';

interface IAsideProps extends WithStyles<typeof styles> {
  title?: RichTextBlock[];
  page_color?: string;
  page_font_color?: string;
  group?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  list_items?: Array<any>;
  page_title?: RichTextBlock[];
  parent_slug?: string;
}

const Aside: React.FunctionComponent<IAsideProps> = ({
  classes,
  title,
  page_color,
  page_font_color,
  group,
  list_items,
  page_title,
  parent_slug,
}) => {
  if (title) {
    return (
      <>
        <List
          className={classes.header}
          style={{ backgroundColor: `${page_color}`, color: `${page_font_color}` }}
        >
          <ListItem>
            <ListItemText primary={`Related ${title[0].text}`} />
          </ListItem>
        </List>
        <List className={classes.body}>
          {list_items.map((item, i) => {
            const group_type = item.node._meta.tags[0];
            const item_title = item.node.title[0].text;
            const slug = item.node._meta.uid;
            const item_link = (
              <Link
                underline="always"
                href={`/${parent_slug}/${slug}/`}
                onClick={() => window.scrollTo(0, 0)}
              >
                {item_title}
              </Link>
            );
            if (group_type === group && item_title !== page_title[0].text) {
              return (
                <ListItem key={i} padding={{ right: 2, left: 6 }}>
                  <ListItemText primary={item_link} />
                </ListItem>
              );
            }
          })}
        </List>
      </>
    );
  } else {
    return (
      <>
        <List
          className={classes.header}
          style={{ backgroundColor: `${page_color}`, color: `${page_font_color}` }}
        >
          <ListItem>
            <ListItemText primary="Quick Links" />
          </ListItem>
        </List>
        <List className={classes.body}>
          {list_items.map((item, i) => {
            const group_type = item.node._meta.tags[0];
            const item_title = item.node.title[0].text;
            const slug = item.node._meta.uid;
            const item_link = (
              //TODO: strip off everything after the group on click, then replace that with href value... this should achieve "jump to section"
              <Link underline="always" href={`#${slug}`}>
                {item_title}
              </Link>
            );
            if (group_type === group && item_title !== page_title[0].text) {
              return (
                <ListItem key={i} padding={{ right: 2, left: 6 }}>
                  <ListItemText primary={item_link} />
                </ListItem>
              );
            }
          })}
        </List>
      </>
    );
  }
};

export default withStyles(styles)(Aside);
